import { type FC } from "react";
import { type CassetteProps } from "./type";
import { CassettePc } from "./uiParts/CassettePc";
import { CassetteSp } from "./uiParts/CassetteSp";

type Props = {
  isSp: boolean;
} & CassetteProps;

export const Presentation: FC<Props> = (props) => {
  const { isSp } = props;
  // 使用箇所はレスポンシブ対応しておらず、PCとSPで細部の仕様が異なるため、別のuiPartsを使用する
  if (isSp) return <CassetteSp {...props} />;

  return <CassettePc {...props} />;
};
